<template>
	<a href="#" :class="className"><slot/></a>
</template>

<script>
export default {
	props: {
		aligned: {
			type: String,
			required: false,
			default: 'right',
			validator: (value) => ['left', 'right'].indexOf(value) !== -1,
		},
	},
	computed: {
		className () {
			return `red-button--${this.aligned}`;
		},
	},
};
</script>


<style lang=less scoped>
	@import (reference) '../assets/_mixins.less';
	@import (reference) '../assets/_breakpoints.less';

	a { display: block; max-width: 260px; margin: 0 auto; padding: 15px 40px 10px 0; border-radius: 5px; color: white; background-color: #E90206; font-size: 18px; font-weight: 600; text-transform: uppercase;
		span { font-size: 18px; font-weight: 600; text-transform: uppercase; }
		&:before { content: ""; display: inline-block; width: 30px; height: 12px; margin: 0 45px 0 20px; background: transparent url(../assets/ico-arrow.svg) 0 0 / contain no-repeat; transform: rotate(90deg); fill: white; }
		&.red-button--right { text-align: right; padding: 15px 0 10px 40px;
			&:before { display: none; }
			&:after { content: ""; display: inline-block; width: 30px; height: 12px; margin: 0 20px 0 45px; background: transparent url(../assets/ico-arrow.svg) 0 0 / contain no-repeat; transform: rotate(-90deg); fill: white; }
		}
	}
	@media @mobile {
		a { max-width: 220px; }
	}
</style>



// WEBPACK FOOTER //
// src/components/RedButton.vue